import * as React from 'react';
import { Button, Col, ControlLabel, FormControl, FormGroup, Row } from 'react-bootstrap';
import ImageModal from './ImageModal';
import { Translate } from '../../../shared/LanguageService';

interface ITemplateFormProps {
    templates: ITemplate[];
    canGenerateTemplate?: boolean;
    isTemplateGenerationActive?: boolean;
    toggleTemplateGeneration?: () => void;
}

export interface ITemplate {
    fileReference: string;
    name: string;
}

class TemplatesForm extends React.Component<ITemplateFormProps, any> {
    constructor(props: ITemplateFormProps, context: any) {
        super(props, context);

        this.state = {
            selectedTemplateIndex: -1
        };
    }

    showModal(index: number) {
        this.setState({ selectedTemplateIndex: index });
    }

    render() {
        const { apiUrl } = window.appConfig;

        return (
            <div>
                <Row>
                    <Col xs={8}>
                        <FormGroup>
                            <ControlLabel>
                                {Translate('view-order/admin-planorder/templates')}
                            </ControlLabel>
                        </FormGroup>
                        {this.props.canGenerateTemplate && (
                            <FormGroup>
                                <FormControl.Static>
                                    {this.props.isTemplateGenerationActive && (
                                        <span>
                                            <i className="material-icons">done</i>{' '}
                                            {Translate(
                                                'view-order/admin-planorder/templates/is-generation-active'
                                            )}
                                        </span>
                                    )}
                                    {!this.props.isTemplateGenerationActive && (
                                        <span>
                                            <i className="material-icons">clear</i>{' '}
                                            {Translate(
                                                'view-order/admin-planorder/templates/is-generation-not-active'
                                            )}
                                        </span>
                                    )}
                                </FormControl.Static>
                            </FormGroup>
                        )}
                    </Col>
                    <Col xs={4}>
                        {(this.props.canGenerateTemplate ||
                            this.props.isTemplateGenerationActive) && (
                            <FormGroup>
                                <FormControl.Static>
                                    {this.props.isTemplateGenerationActive && (
                                        <Button
                                            onClick={this.props.toggleTemplateGeneration}
                                            className="pull-right"
                                        >
                                            {Translate(
                                                'view-order/admin-planorder/templates/is-generation-active/button'
                                            )}
                                        </Button>
                                    )}
                                    {!this.props.isTemplateGenerationActive && (
                                        <Button
                                            onClick={this.props.toggleTemplateGeneration}
                                            className="pull-right"
                                        >
                                            {Translate(
                                                'view-order/admin-planorder/templates/is-generation-not-active/button'
                                            )}
                                        </Button>
                                    )}
                                </FormControl.Static>
                            </FormGroup>
                        )}
                    </Col>
                </Row>
                <FormGroup>
                    <FormControl.Static>
                        {this.props.templates &&
                            this.props.templates.map((x, index) => (
                                <img
                                    onClick={() => {
                                        this.showModal(index);
                                    }}
                                    key={'template-' + index}
                                    src={`${apiUrl}/file/${x.fileReference}`}
                                    style={{
                                        maxWidth: '100px',
                                        maxHeight: '100px'
                                    }}
                                />
                            ))}
                    </FormControl.Static>

                    {this.state.selectedTemplateIndex > -1 && (
                        <ImageModal
                            filename={this.props.templates[this.state.selectedTemplateIndex].name}
                            fileReference={
                                this.props.templates[this.state.selectedTemplateIndex].fileReference
                            }
                            onClose={() => {
                                this.setState({ selectedTemplateIndex: -1 });
                            }}
                        />
                    )}
                </FormGroup>
            </div>
        );
    }
}

export default TemplatesForm;
